import { render } from "./AsahiLogoNew.vue?vue&type=template&id=3a103008&ts=true"
import script from "./AsahiLogoNew.vue?vue&type=script&lang=ts"
export * from "./AsahiLogoNew.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__